function DataTableSettings() {
  // ... existing DataTableSettings code ...
  this.defaultBootstrapTable = function() {
    return {
      "pagingType": 'bootstrap',
      "dom": 'tp',
      "aaSorting": [ ],
      "language": {
        "searchPlaceholder": "Search",
        "search": ""
      }
    };
  }
}

/* API method to get paging information */
$.fn.dataTableExt.oApi.fnPagingInfo = function ( oSettings )
{
    // ... existing fnPagingInfo code ...
    return {
        "iStart":         oSettings._iDisplayStart,
        "iEnd":           oSettings.fnDisplayEnd(),
        "iLength":        oSettings._iDisplayLength,
        "iTotal":         oSettings.fnRecordsTotal(),
        "iFilteredTotal": oSettings.fnRecordsDisplay(),
        "iPage":          oSettings._iDisplayLength === -1 ?
            0 : Math.ceil( oSettings._iDisplayStart / oSettings._iDisplayLength ),
        "iTotalPages":    oSettings._iDisplayLength === -1 ?
            0 : Math.ceil( oSettings.fnRecordsDisplay() / oSettings._iDisplayLength )
    };
}

/* Bootstrap style pagination control */
$.extend( $.fn.dataTableExt.oPagination, {
    "bootstrap": {
        "fnInit": function( oSettings, nPaging, fnDraw ) {
            // ... existing fnInit code ...
            var oLang = oSettings.oLanguage.oPaginate;
            var fnClickHandler = function ( e ) {
                e.preventDefault();
                if ( oSettings.oApi._fnPageChange(oSettings, e.data.action) ) {
                    fnDraw( oSettings );
                }
            };

            $(nPaging).addClass('pagination').append(
                '<ul>'+
                    '<li class="prev disabled"><a href="#">&larr; '+oLang.sPrevious+'</a></li>'+
                    '<li class="next disabled"><a href="#">'+oLang.sNext+' &rarr; </a></li>'+
                '</ul>'
            );
            var els = $('a', nPaging);
            // Use .off().on() for robust event binding, especially with Turbo
            $(els[0]).off( 'click.DT' ).on( 'click.DT', { action: "previous" }, fnClickHandler );
            $(els[1]).off( 'click.DT' ).on( 'click.DT', { action: "next" }, fnClickHandler );
        },

        "fnUpdate": function ( oSettings, fnDraw ) {
            // ... existing fnUpdate code ...
            var iListLength = 5;
            var oPaging = oSettings.oInstance.fnPagingInfo();
            var an = oSettings.aanFeatures.p;
            var i, ien, j, sClass, iStart, iEnd, iHalf=Math.floor(iListLength/2);

            if ( oPaging.iTotalPages < iListLength) {
                iStart = 1;
                iEnd = oPaging.iTotalPages;
            }
            else if ( oPaging.iPage <= iHalf ) {
                iStart = 1;
                iEnd = iListLength;
            } else if ( oPaging.iPage >= (oPaging.iTotalPages-iHalf) ) {
                iStart = oPaging.iTotalPages - iListLength + 1;
                iEnd = oPaging.iTotalPages;
            } else {
                iStart = oPaging.iPage - iHalf + 1;
                iEnd = iStart + iListLength - 1;
            }

            for ( i=0, ien=an.length ; i<ien ; i++ ) {
                // Remove the middle elements
                $('li:gt(0)', an[i]).filter(':not(:last)').remove();

                // Add the new list items and their event handlers
                for ( j=iStart ; j<=iEnd ; j++ ) {
                    sClass = (j==oPaging.iPage+1) ? 'class="active"' : '';
                    $('<li '+sClass+'><a href="#">'+j+'</a></li>')
                        .insertBefore( $('li:last', an[i])[0] )
                        // Use .off().on() for robust event binding
                        .off('click')
                        .on('click', function (e) {
                            e.preventDefault();
                            // Ensure oSettings is still valid in this context
                            if (oSettings && oSettings._iDisplayStart !== undefined) {
                                oSettings._iDisplayStart = (parseInt($('a', this).text(),10)-1) * oPaging.iLength;
                                fnDraw( oSettings );
                            } else {
                                console.error("DataTable settings object invalid in pagination click handler");
                            }
                        } );
                }

                // Add / remove disabled classes from the static elements
                if ( oPaging.iPage === 0 ) {
                    $('li:first', an[i]).addClass('disabled');
                } else {
                    $('li:first', an[i]).removeClass('disabled');
                }

                if ( oPaging.iPage === oPaging.iTotalPages-1 || oPaging.iTotalPages === 0 ) {
                    $('li:last', an[i]).addClass('disabled');
                } else {
                    $('li:last', an[i]).removeClass('disabled');
                }
            }
        }
    }
} );

jQuery.extend( jQuery.fn.dataTableExt.oSort, {
    "file-size-pre": function ( a ) {
        // ... existing file-size-pre code ...
        var x = a.substring(0,a.length - 2);
        var x_unit = (a.substring(a.length - 2, a.length) == "MB" ?
            1000 : (a.substring(a.length - 2, a.length) == "GB" ? 1000000 : 1));
        // Add check for NaN
        var val = parseInt( x * x_unit, 10 );
        return isNaN(val) ? 0 : val;
    },

    "file-size-asc": function ( a, b ) {
        // ... existing file-size-asc code ...
        return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    },

    "file-size-desc": function ( a, b ) {
        // ... existing file-size-desc code ...
        return ((a < b) ? 1 : ((a > b) ? -1 : 0));
    }
} );

$.extend( $.fn.dataTableExt.oStdClasses, {
    "sWrapper": "dataTables_wrapper form-inline"
} );

// Restore search input value from state on init - Keep this, it runs per-table
$(document).on( 'init.dt', function ( e, settings ) {
    var api = new $.fn.dataTable.Api( settings );
    var state = api.state.loaded();
    var dataTableName = e.target.dataset.table; // Ensure tables have data-table attribute if using this
    if(state && state.search && state.search.search && dataTableName) {
      // Use a more specific selector if possible, or ensure data-table-search is unique
      $("[data-table-search='"+dataTableName+"']").val(state.search.search);
    }
});

// Selectors for all tables managed by this script
const ALL_DATATABLE_SELECTORS = [
  '.dataTable',
  '.dataTableNew',
  '.dataTableCompanyMemberships',
  '.dataTableBulletins',
  '.dataTablePage',
  '.dataTableRegistrationPreview',
  '.dataTableDiscountPreview',
  '.dataTableSpeakerPreview',
  '.dataTableAgendaPreview',
  '.dataTableTagPreview',
  '.dataTableKeywordPreview',
  '.dataTableCompaniesPreview',
  '.dataTableTeamMemberships',
  '.dataTableReorderable',
  '#categories-table' // Specific ID
].join(', ');

function destroyDataTables() {
  console.log("Attempting to destroy DataTables..."); // Debug log
  document.querySelectorAll(ALL_DATATABLE_SELECTORS).forEach(table => {
    if ($.fn.DataTable.isDataTable(table)) {
      console.log("Destroying DataTable:", table); // Debug log
      $(table).DataTable().destroy();
      // Avoid $(table).empty() as it removes the <table> structure itself.
      // Clear only header/footer if needed, or let DataTables handle it on re-init.
      // $(table).find('thead, tfoot').empty();
    }
  });
}

function initializeDataTables() {
  console.log("Initializing DataTables..."); // Debug log
  // Destroy any potentially lingering tables first
  destroyDataTables();

  // --- Initialization for '.dataTable' ---
  $('.dataTable').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return; // Skip if already initialized
    console.log("Initializing .dataTable:", this); // Debug log
    try {
      const table = $(this).DataTable({ // Use modern DataTable()
        "lengthChange": false, // Use modern names
        "stateSave": true,
        "autoWidth": false,
        "destroy": true, // Add destroy option
        "dom": "<'row-fluid'<'span1'l><'span11'f>r>t<'row-fluid'<'span1'i><'span11 pull-right'p>>", // sDom -> dom
        "pagingType": "bootstrap", // sPaginationType -> pagingType
        "order": [], // aaSorting -> order
        "language": { // oLanguage -> language
          "search": "Filter:", // sSearch -> search
          "info": "", // sInfo -> info
          "infoFiltered": "", // sInfoFiltered -> infoFiltered
          "infoEmpty": "" // sInfoEmpty -> infoEmpty
        },
        // Removed problematic drawCallback reload logic
        // "drawCallback": function(settings) { ... }
      });
    } catch (e) {
      console.error("Error initializing .dataTable:", e, this);
    }
  });

  // --- Initialization for '.dataTableNew' ---
  $('.dataTableNew').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
    console.log("Initializing .dataTableNew:", this); // Debug log
    try {
      $(this).DataTable( {
        "pagingType": 'bootstrap',
        "dom": 'tp',
        "stateSave": true,
        "autoWidth": false,
        "destroy": true, // Add destroy option
        "order": [ ], // aaSorting -> order
        "language": {
          "searchPlaceholder": "Search",
          "search": ""
        },
        "drawCallback": function (oSettings) {
          // Re-initialize stars plugin if needed
          if(typeof $.fn.stars === 'function' && $('span.stars:not(:has(span))', this).length) {
            // Ensure stars() handles re-initialization gracefully or destroy first
            // $('span.stars:not(:has(span))', this).stars('destroy').stars(); // Example if destroy needed
             $('span.stars:not(:has(span))', this).stars();
          }
        }
      });
    } catch (e) {
      console.error("Error initializing .dataTableNew:", e, this);
    }
  });

  // --- Initialization for '.dataTableCompanyMemberships' ---
  $('.dataTableCompanyMemberships').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
    console.log("Initializing .dataTableCompanyMemberships:", this); // Debug log
    try {
      $(this).DataTable( {
        "order": [[1, 'desc']], // Keep specific order
        "stateSave": true,
        "autoWidth": false,
        "destroy": true, // Add destroy option
        "pagingType": 'bootstrap',
        "dom": 'tp',
        // "aaSorting": [ ], // Remove aaSorting if 'order' is used
        "language": {
          "searchPlaceholder": "Search",
          "search": ""
        }
      });
    } catch (e) {
      console.error("Error initializing .dataTableCompanyMemberships:", e, this);
    }
  });

  // --- Initialization for '.dataTableBulletins' ---
  $('.dataTableBulletins').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
     console.log("Initializing .dataTableBulletins:", this); // Debug log
    try {
      $(this).DataTable( {
        "order": [[2, 'desc']], // Keep specific order
        "stateSave": true,
        "autoWidth": false,
        "destroy": true, // Add destroy option
        "pagingType": 'bootstrap',
        "dom": 'tp',
        // "aaSorting": [ ], // Remove aaSorting if 'order' is used
        "language": {
          "searchPlaceholder": "Search",
          "search": ""
        }
      });
    } catch (e) {
      console.error("Error initializing .dataTableBulletins:", e, this);
    }
  });

  // --- Initialization for '.dataTablePage' ---
  $('.dataTablePage').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
    console.log("Initializing .dataTablePage:", this); // Debug log
    try {
      $(this).DataTable( { // Use modern DataTable()
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]], // aLengthMenu -> lengthMenu
        "stateSave": true,
        "autoWidth": false,
        "destroy": true, // Add destroy option
        "pagingType": "bootstrap", // sPaginationType -> pagingType
        "language": { // oLanguage -> language
              "search": "Filter:", // sSearch -> search
              "lengthMenu": "show _MENU_ per page", // sLengthMenu -> lengthMenu
              "info": "", // sInfo -> info (already empty)
            },
        // "sInfo": "", // Remove legacy sInfo
      });
    } catch (e) {
      console.error("Error initializing .dataTablePage:", e, this);
    }
  });

  // --- Initialization for Preview Tables (Registration, Discount, Speaker, etc.) ---
  const previewTableSelectors = [
    '.dataTableRegistrationPreview',
    '.dataTableDiscountPreview',
    '.dataTableSpeakerPreview',
    '.dataTableAgendaPreview',
    '.dataTableTagPreview',
    '.dataTableKeywordPreview',
    '.dataTableCompaniesPreview'
  ].join(', ');

  $(previewTableSelectors).each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
    const selector = $(this).attr('class').split(' ').find(cls => cls.startsWith('dataTable') && cls.endsWith('Preview'));
    console.log(`Initializing ${selector}:`, this); // Debug log
    try {
      // Attempt to get columns from data attribute, fallback to empty array if not defined
      let columnsConfig = $(this).data('columns') || [];
      // Ensure columnsConfig is an array if it exists
      if (columnsConfig && !Array.isArray(columnsConfig)) {
          console.warn(`Invalid columns data for ${selector}, expected array:`, columnsConfig);
          columnsConfig = []; // Reset to empty if invalid
      }

      $(this).DataTable( {
        "lengthChange": false, // bLengthChange -> lengthChange
        "ordering": false,
        "searching": false, // Explicitly disable searching
        "dom": "t", // sDom -> dom
        "destroy": true, // Add destroy option
        "order": [ ], // aaSorting -> order
        "language": {
          "searchPlaceholder": "Search", // Unused with dom: "t"
          "search": "", // Unused
          "emptyTable": "No data available in table"
        },
        "autoWidth": false, // Set autoWidth to false generally
        "stripeClasses": [], // Keep if needed
        // Use columnsConfig if it's a valid array with items
        "columns": columnsConfig.length > 0 ? columnsConfig : undefined
      });
    } catch (e) {
      console.error(`Error initializing ${selector}:`, e, this);
    }
  });


  // --- Initialization for '.dataTableTeamMemberships' ---
  $('.dataTableTeamMemberships').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
    console.log("Initializing .dataTableTeamMemberships:", this); // Debug log
    try {
      const inviteModalName = $(this).data('invite-modal-name'); // Get modal name before init
      $(this).DataTable( {
        "pagingType": 'bootstrap',
        "dom": 'tp',
        "stateSave": true,
        "autoWidth": false,
        "destroy": true, // Add destroy option
        "order": [ ], // aaSorting -> order
        "language": {
          "searchPlaceholder": "Search",
          "search": "",
          "zeroRecords": "" // Keep custom zeroRecords handling for drawCallback
        },
        "drawCallback": function (settings) {
          var api = new $.fn.dataTable.Api( settings );
          // Use the captured inviteModalName
          if (api.page.info().recordsDisplay === 0 && inviteModalName) {
            // Show invite button only when table is empty (after search or initially)
            // Ensure the selector targets the correct empty cell within this specific table instance
            const emptyCellSelector = '#' + settings.sTableId + ' .dataTables_empty';
            $(emptyCellSelector).html("<span class='empty-state-search-results'>" + (api.search() ? "No results for: " + api.search() : "No members yet.") + "</span><span class='pull-right'><a class='btn btn-primary' href='#' data-target='#"+inviteModalName+"' data-toggle='modal'>Invite</a></span>");
          }
        }
      });
    } catch (e) {
      console.error("Error initializing .dataTableTeamMemberships:", e, this);
    }
  });

  // --- Initialization for '.dataTableReorderable' ---
  $('.dataTableReorderable').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
    console.log("Initializing .dataTableReorderable:", this); // Debug log
    const $tableElement = $(this); // Cache the jQuery object
    const reorderUrl = $tableElement.data('url'); // Get URL before init

    if (!reorderUrl) {
      console.error("Missing data-url for reorderable table:", this);
      return; // Skip initialization if URL is missing
    }

    try {
      const table = $tableElement.DataTable( { // Use modern DataTable()
        "rowReorder": true,
        "paging": false,
        "searching": false,
        "destroy": true, // Add destroy option
        "info": false // Hide info display
      });

      // Re-bind event listener using .off().on() on the API instance
      table.off('row-reordered.dt').on('row-reordered.dt', function (e, diff, edit) {
        var positions = {};
        // Use the captured reorderUrl
        for ( var i=0, ien=diff.length ; i<ien ; i++ ) {
          // Ensure node id exists and is suitable for the key
          if (diff[i].node && diff[i].node.id) {
            positions[diff[i].node.id] = diff[i].newPosition + 1; // Assuming 1-based indexing server-side
          } else {
             console.warn("Missing node ID during reorder:", diff[i].node);
          }
        };
        if (Object.keys(positions).length > 0) {
          $.ajax({
            type: 'PUT',
            url: reorderUrl, // Use captured URL
            dataType: 'json',
            data: { position: positions },
            error: function(jqXHR, textStatus, errorThrown) {
              console.error("Error saving reordered positions:", textStatus, errorThrown);
              // Optionally provide user feedback (e.g., revert order visually or show message)
            }
          });
        }
      });
    } catch (e) {
      console.error("Error initializing .dataTableReorderable:", e, this);
    }
  });


  // --- Initialization for '#categories-table' ---
  $('#categories-table').each(function() {
    if ($.fn.DataTable.isDataTable(this)) return;
    console.log("Initializing #categories-table:", this); // Debug log
    const $tableElement = $(this); // Cache jQuery object

    try {
      const table = $tableElement.DataTable( {
        "pagingType": 'bootstrap',
        "stateSave": true,
        "autoWidth": false,
        "destroy": true, // Add destroy option
        "dom": 'tp',
        "order": [ ], // aaSorting -> order
        "language": {
          "searchPlaceholder": "Search",
          "search": ""
        }
      });

      // Re-bind event listener using .off().on() on the tbody
      // Use a more specific selector if possible, e.g., '#categories-table > tbody'
      $tableElement.children('tbody').off('click', 'tr').on('click', 'tr', function () {
          var tr = $(this);
          var row = table.row( tr ); // Use the initialized table variable

          if (!row) { // Check if row object is valid
              console.error("Could not get row API instance for:", tr);
              return;
          }

          if ( row.child.isShown() ) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
          }
          else {
            // Open this row
            var is_event_scope = tr.data("event-scope");
            var tags_url = tr.data("tags-remote-url");

            if (!tags_url) {
              console.error("Missing data-tags-remote-url on category row:", tr);
              row.child( errorLoader() ).show(); // Show error if URL is missing
              tr.addClass('shown'); // Add 'shown' even on error
              return;
            }
            // Check for notefit_config existence and required tokens
            if (typeof notefit_config === 'undefined' || !notefit_config.api_auth_token || !notefit_config.team_api_auth_token) {
               console.error("notefit_config missing or incomplete for category tags AJAX");
               row.child( errorLoader() ).show();
               tr.addClass('shown');
               return;
            }

            row.child( renderLoader() ).show();
            tr.addClass('shown'); // Add 'shown' immediately

            $.ajax({
              url: tags_url,
              beforeSend: function(request) {
                request.setRequestHeader("X-Notefit-Planner-Api-Auth-Token", notefit_config.api_auth_token);
                request.setRequestHeader("X-Notefit-Team-Api-Auth-Token", notefit_config.team_api_auth_token);
              },
              success: function(data){
                // Check if row and child still exist and are shown before rendering
                if (table.row(tr).length && row.child.isShown()) {
                    row.child( renderTags(data, is_event_scope) ).show();
                }
              },
              error: function(jqXHR, textStatus, errorThrown) { // Use 'error'
                console.error("Error fetching category tags:", textStatus, errorThrown);
                 // Check if row and child still exist and are shown before rendering error
                if (table.row(tr).length && row.child.isShown()) {
                    row.child( errorLoader() ).show();
                }
              }
            });
          }
      });
    } catch (e) {
      console.error("Error initializing #categories-table:", e, this);
    }
  });
  // END TAGS AND CATEGORIES TABLES

  console.log("Finished initializing DataTables."); // Debug log
}

// --- Turbo Event Listeners ---

// Destroy tables before Turbo caches the page
document.addEventListener('turbo:before-cache', function() {
  console.log("Turbo event: turbo:before-cache"); // Debug log
  destroyDataTables();
});

// Initialize tables after Turbo loads a page (fresh or cached)
document.addEventListener('turbo:load', function() {
  console.log("Turbo event: turbo:load"); // Debug log
  initializeDataTables();
});

// Removed old isInitialized flag, currentTables, destroyExistingTables,
// and other Turbo/ready listeners.
